import { render, staticRenderFns } from "./RelatorioSummaryTab.vue?vue&type=template&id=86361b6a&scoped=true"
import script from "./RelatorioSummaryTab.vue?vue&type=script&lang=js"
export * from "./RelatorioSummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86361b6a",
  null
  
)

export default component.exports